export default __webpack_public_path__ + "static/media/theme_03.e0f5cd29.png";